"use client";
import { ForgetPasswordSchema } from "@/app/schemas/auth-schemas";
import { useState, useTransition } from "react";
import { HttpResponse } from "../types/response-types";
const ForgetPasswordForm: React.FC = () => {
  const [isPending, startTransition] = useTransition();
  const [emailSent, setEmailSent] = useState<boolean>(false);
  const [errorMessages, setErrorMessages] = useState<string[] | undefined>();

  const [email, setEmail] = useState<string>("");
  const handleSubmitForm = async () => {
    const data = {
      email: email,
    };

    const result = ForgetPasswordSchema.safeParse(data);

    if (!result.success) {
      setErrorMessages(result.error.issues.map((i) => i.message));
      return;
    }
    startTransition(async () => {
      const res = await fetch("/api/auth/forgot-password", {
        method: "POST",
        body: JSON.stringify(result.data),
      });
      const json = (await res.json()) as HttpResponse;
      if (json.isSuccess) {
        setEmailSent(true);
      } else {
        setErrorMessages(["Something went wrong, please try again."]);
      }
    });
  };

  // const formRef = useRef() as React.MutableRefObject<HTMLFormElement>;

  return (
    <form>
      <h4 className="nv-heading-4 text-primary">Reset Password</h4>
      {errorMessages && (
        <div className="form-field error-field ">
          {errorMessages.map((m, idx) => (
            <span className="text-danger  nv-body-sm" key={idx}>
              {m}
            </span>
          ))}
        </div>
      )}
      {!emailSent ? (
        <>
          <p className="nv-body text-gray-600">
            Enter your email address, we will send you link to renew your
            password.
          </p>
          <div className="form-control-group">
            <input
              className="form-control"
              type="email"
              name="email"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value! as string)}
            />
            <button
              className="btn login-form__submit-btn text-white"
              disabled={isPending}
              onClick={(e) => {
                e.preventDefault();
                handleSubmitForm();
              }}
            >
              {isPending && (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                >
                  {" "}
                </span>
              )}{" "}
              Send Link
            </button>
          </div>
        </>
      ) : (
        <div>
          <p className="nv-body text-gray-600">
            Password reset email is sent, please check your email.
          </p>
          <button
            className="
         btn login-form__submit-btn text-white nv-body-sm nv-fw-semibold"
            onClick={(e) => {
              e.preventDefault();
              handleSubmitForm();
            }}
          >
            <span>Resend Link</span>
          </button>
        </div>
      )}
    </form>
  );
};

export { ForgetPasswordForm };
